// Seasonal promotions slider (tu-promos.liquid, 2026-09-07 variant 2 "Full
// bleed, one at a time" -- Docs/decisions/design-explorations/
// variants-offers-2026-09-07.html). A standalone script, not shared with
// tu-offers.js (a fixed badge plus two small text/CTA stacks) or tu-video.js
// (a single player): here every [data-tu-promos-slide] is a full-bleed photo
// stacked on the same grid cell, one .is-active at a time, so the whole
// slide -- photo, scrim, copy, button -- crossfades together.
//
// Behaviour: advances every `turn_seconds` (data-tu-promos-turn on the
// section), pausing while a mouse pointer is over the section, while a
// finger is on it (plus a short settle window after touchend), while the
// tab is hidden, while the visitor has pressed the pause control, and never
// at all under prefers-reduced-motion (which also turns the crossfade off,
// see the CSS). The thin bar under the slide is not a static dash per
// slide -- it fills in real time over `turn_seconds` and snaps back to 0%
// on every advance, driven by the same rAF loop that drives the timer, so
// it freezes exactly when rotation pauses rather than drifting on its own
// CSS animation clock.
//
// 2026-09-07: setActive() used to tabindex-manage only the first <a> per
// slide (the CTA -- every slide had exactly one). Now a slide can carry a
// `products` payload with three more anchors (the fanned cards), so it
// walks every <a> in the slide instead.
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function bind(section) {
    if (section.tuPromosBound) return;
    section.tuPromosBound = true;

    var slides = [].slice.call(section.querySelectorAll('[data-tu-promos-slide]'));
    var n = slides.length;
    if (!n) return;

    var barFill = section.querySelector('[data-tu-promos-bar-fill]');
    var cur = 0;

    // 2026-10-06 (image sharpness): the slides' photos are now the full 2000px originals (a phone shows them at 0.25
    // sharpness from the 800px file), so five of them fetched at page load would cost a phone ~750 KB more than before
    // and compete with the hero. A slide's photo and its product cards are only requested when it is the one on show or
    // the next one, and only once the section's turn has come (the band loader's tu:band-load, or the section within
    // a screen of the viewport). tu-system.css keeps background-image: none on a slide until it carries .is-armed.
    var go = false;
    function arm(el) {
      if (!el || el.classList.contains('is-armed')) return;
      el.classList.add('is-armed');
      if (window.TuSkel) { window.TuSkel.bg(el); [].forEach.call(el.querySelectorAll('[data-tu-bgs]'), window.TuSkel.bg); }
    }
    function armNear() { if (!go) return; arm(slides[cur]); arm(slides[(cur + 1) % n]); }
    function start() { if (go) return; go = true; armNear(); }
    section.addEventListener('tu:band-load', start);
    if ('IntersectionObserver' in window) {
      var armIo = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { start(); armIo.disconnect(); } }, { rootMargin: '100% 0px' });
      armIo.observe(section);
    } else { start(); }

    function setActive(i) {
      i = ((i % n) + n) % n;
      cur = i;

      slides.forEach(function (el, j) {
        var on = j === i;
        el.classList.toggle('is-active', on);
        if (on) { el.removeAttribute('aria-hidden'); } else { el.setAttribute('aria-hidden', 'true'); }
        // A payload slide (badge or products) can carry more than one anchor --
        // the CTA plus up to three product cards -- so every link in the slide
        // gets tabindex managed, not just the first.
        var links = el.querySelectorAll('a');
        for (var k = 0; k < links.length; k++) {
          if (on) { links[k].removeAttribute('tabindex'); } else { links[k].setAttribute('tabindex', '-1'); }
        }
      });

      armNear();
      if (barFill) {
        barFill.style.transition = 'none';
        barFill.style.width = '0%';
        void barFill.offsetWidth; // force reflow so the next width change transitions again
        barFill.style.transition = '';
      }
    }

    var userPaused = reduced;
    var playpause = section.querySelector('[data-tu-promos-playpause]');
    function reflectPlaypause() {
      if (!playpause) return;
      playpause.classList.toggle('is-paused', userPaused);
      playpause.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
      playpause.setAttribute('aria-label', userPaused ? 'Play promotion rotation' : 'Pause promotion rotation');
    }
    if (playpause) {
      if (reduced || n <= 1) { playpause.disabled = true; }
      playpause.addEventListener('click', function () {
        userPaused = !userPaused;
        reflectPlaypause();
      });
      reflectPlaypause();
    }

    var hover = false, touching = false;
    section.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
    section.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hover = false; });
    section.addEventListener('touchstart', function () { touching = true; }, { passive: true });
    section.addEventListener('touchend', function () { setTimeout(function () { touching = false; }, 2500); }, { passive: true });

    var secs = parseFloat(section.dataset.tuPromosTurn || '7') || 0;
    var last = 0, t = 0;

    // Arrows (2026-09-11). `t = 0` on each press is the point: without it the
    // timer keeps its accumulated elapsed time and the slide a visitor just
    // chose can flip away almost immediately. Stepping restarts the dwell.
    function step(d) { setActive(cur + d); t = 0; last = 0; }
    var prevBtn = section.querySelector('[data-tu-promos-prev]');
    var nextBtn = section.querySelector('[data-tu-promos-next]');
    if (n > 1) {
      if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
    } else {
      // One slide: the arrows would do nothing, so they should not be
      // focusable or announced at all.
      if (prevBtn) prevBtn.hidden = true;
      if (nextBtn) nextBtn.hidden = true;
    }
    // perf plan A6, audit 2026-09-15: this was a permanent requestAnimationFrame
    // loop -- a style + layout pass 60 times a second for the life of the page,
    // in or out of view (a6-who.mjs: 600 frames in 10 s with the section
    // off-screen). Now a 200 ms interval that runs only while the section is in
    // view and the tab visible; the bar's 120 ms width transition
    // (tu-system.css .tu-promos__bar i) makes the 5 Hz writes read as continuous.
    var timer = null, inView = true;
    function tick() {
      var now = performance.now();
      if (!last) last = now;
      var dt = now - last;
      last = now;
      var run = secs > 0 && !reduced && !userPaused && !hover && !touching && !document.hidden && n > 1;
      if (run) {
        t += dt;
        if (t >= secs * 1000) {
          t = 0;
          setActive(cur + 1);
        }
        if (barFill) { barFill.style.width = Math.min(100, (t / (secs * 1000)) * 100) + '%'; }
      } else {
        last = 0; // next running tick recomputes dt from scratch instead of a big jump
      }
    }
    function startTick() { if (!timer) { last = 0; timer = setInterval(tick, 200); } }
    function stopTick() { if (timer) { clearInterval(timer); timer = null; last = 0; } }
    function syncTick() { if (inView && !document.hidden) startTick(); else stopTick(); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries.some(function (e) { return e.isIntersecting; });
        syncTick();
      }, { threshold: 0.1 }).observe(section);
    }
    document.addEventListener('visibilitychange', syncTick);
    syncTick();

    // 2026-10-06, skeleton sweep: the photo is a CSS background (the breakpoint candidate is picked in
    // tu-system.css), so no <img> for tu-card.js to shimmer. Read the URL the slide is actually using now,
    // probe it with an Image (same URL, so the browser fetches it once) and add .is-loaded when it lands;
    // CSS shows the sheen on the active slide until then. Re-run when a breakpoint is crossed.
    function watchPhotos() {
      slides.forEach(function (el) {
        var m = /url\(["']?([^"')]+)["']?\)/.exec(getComputedStyle(el).backgroundImage);
        var url = m && m[1];
        if (!url) { el.classList.add('is-loaded'); return; }
        if (el.tuPromosUrl === url) return;
        el.tuPromosUrl = url;
        el.classList.remove('is-loaded');
        var im = new Image();
        im.onload = im.onerror = function () { if (el.tuPromosUrl === url) el.classList.add('is-loaded'); };
        im.src = url;
        if (im.complete) im.onload();
      });
    }
    watchPhotos();
    ['(min-width: 750px)', '(min-width: 1200px)'].forEach(function (q) {
      var mq = window.matchMedia(q);
      if (mq.addEventListener) mq.addEventListener('change', watchPhotos);
    });

    setActive(0);
  }

  function init() { document.querySelectorAll('[data-tu-promos]').forEach(bind); }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();
